// Public destinations the site and the app link to, in one place (website
// build brief section 3: reuse DOCS_URL instead of scattering strings).
// Every URL here was checked to resolve before it was added; do not add a
// support address, social account or legal page that does not exist.

/** The documentation website (docsify, repository keeper0x/thevault-docs). */
export const DOCS_URL = 'https://keeper0x.github.io/thevault-docs/';

/** The source repository. */
export const SOURCE_URL = 'https://github.com/keeper0x/thevault';

/** Contact, given by the owner on 12 October 2026 (zeroqube.io's MX records route mail through Cloudflare). */
export const SUPPORT_EMAIL = 'hello@zeroqube.io';
export const BUSINESS_EMAIL = 'business@zeroqube.io';
export const X_HANDLE = 'ZeroQube_io';
export const X_URL = `https://x.com/${X_HANDLE}`;

/** A page of the documentation website (docsify routes are hash paths relative to its root). */
export function docsPage(path: string): string {
  return `${DOCS_URL}#/${path.replace(/^\/+/, '')}`;
}

/** A file in the source repository's default branch. */
export function sourceFile(path: string): string {
  return `${SOURCE_URL}/blob/master/${path.replace(/^\/+/, '')}`;
}
